import React from "react";
import {
  getHourFromTimestamp,
  determineTextColor,
  LinkifyMe,
} from "helpers/efficeHelpers";
import MessageSendFailure from "../MessageSendFailure/MessageSendFailure";

const NormalMinimised = ({ efficeData, ppl }) => {
  return (
    <>
      <div className="Txt-effice-left-side">
        <div className="Txt-no-avatar-hover">
          {getHourFromTimestamp(efficeData.created_at)}
        </div>
      </div>
      <div className="Txt-effice-middle-content">
        <div className={determineTextColor(efficeData)}>
          <LinkifyMe>{efficeData.content}</LinkifyMe>
          {efficeData.editted_at ? (
            <span className="Txt-edited-font">&emsp; - Edited</span>
          ) : null}
          {efficeData.failed ? <MessageSendFailure /> : null}
        </div>
      </div>
    </>
  );
};

export default NormalMinimised;
